<p-dialog header="Create Template"
          [visible]="visible()"
          (visibleChange)="visible.set($event)"
          [modal]="true"
          [style]="{width: '28rem'}"
          data-testid="create-template-from-ta-dialog">
  <div class="flex flex-col gap-4 text-sm font-['Inter']">
    <div class="text-surface-700">
      @if (ta(); as source) {
        Save <b>{{ source.taNumber }}</b> as a template.
      } @else {
        Give your new template a title.
      }
    </div>
    <div class="flex flex-col gap-2">
      <label for="template-title"><span class="text-text-color">Template Title</span><span class="text-red-700">*</span></label>
      <input id="template-title"
             type="text"
             pInputText
             maxlength="256"
             placeholder="e.g. Weekly Meeting Template"
             [ngModel]="name()"
             (ngModelChange)="setName($event)"
             (keydown.enter)="create()"
             data-testid="create-template-from-ta-name" />
      @if (error()) {
        <span class="text-red-700" data-testid="create-template-from-ta-error">{{ error() }}</span>
      }
    </div>
  </div>
  <ng-template #footer>
    <p-button label="Cancel" severity="secondary" [outlined]="true" (onClick)="visible.set(false)"></p-button>
    <p-button label="Create Template"
              [disabled]="!name().trim() || saving()"
              (onClick)="create()"
              data-testid="create-template-from-ta-confirm"></p-button>
  </ng-template>
</p-dialog>
